import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import useTranslation from "next-translate/useTranslation";
import getForm from "lib/getForm";

const CalculatorResultFormSkeleton = dynamic(() =>
  import("components/Form/CalculatorResultFormSkeleton")
);
const CalculatorResultForm = dynamic(
  () => import("components/Form/CalculatorResultForm"),
  {
    ssr: false,
  }
);

const FORM_IDS = {
  fr: "calculator_result",
  en: "calculator_result",
};

export default function CalculatorResult({ values }) {
  const { lang } = useTranslation();
  const [form, setForm] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const formId = FORM_IDS[lang] || FORM_IDS.fr;

  useEffect(() => {
    if (typeof form === "undefined") {
      const controller = new AbortController();
      getForm(formId, true, controller.signal)
        .then((fields) => {
          setForm({
            id: formId,
            fields,
          });
        })
        .catch(console.error)
        .finally(() => setIsLoading(false));
      return () => controller.abort();
    }
    return undefined;
  }, [formId]);

  return isLoading ? (
    <CalculatorResultFormSkeleton />
  ) : (
    <CalculatorResultForm
      {...form}
      defaultValues={{ values: JSON.stringify(values) }}
    />
  );
}
